import { Card } from "reactstrap";
import OvertimeTable from "../components/Overtime";
import { DateFiltersProvider } from "../hooks/useDateFilters";
import { FiltersProvider } from "../filtersContext";

function MyOvertimes() {
    return (
        <Card className="px-0 m-0 h-100 position-static">
            <FiltersProvider>
                <DateFiltersProvider>
                    <OvertimeTable isMyOvertime={true} />
                </DateFiltersProvider>
            </FiltersProvider>
        </Card>
    );
}

export default MyOvertimes;
